const LayoutManage = () => import('@/views/manage/layout')

const routes = [
//   {
//   path: '/user',
//   redirect: '/user/index',
//   component: LayoutManage,
//   children: [{
//     path: 'index',
//     component: () => import('@/views/manage/user/index'),
//     meta: {
//       title: '工作台',
//       img: '1.png'
//     }
//   }]
// }, 
{
  path: '/user/entrust',
  redirect: '/user/entrust/index',
  component: LayoutManage,
  children: [{
    path: 'index',
    component: () => import('@/views/manage/user/entrust/index'),
    meta: {
      title: '我的委托',
      img: '3.png'
    }
  }]
}, {
  path: '/user/quality',
  redirect: '/user/quality/questionnaire',
  component: LayoutManage,
  meta: {
    title: '企业质量管理',
    img: '2.png'
  },
  children: [{
    path: 'questionnaire',
    component: () => import('@/views/manage/user/quality/questionnaire'),
    meta: {
      title: '质量问卷'
    }
  }, {
    path: 'diagnosis',
    component: () => import('@/views/manage/user/quality/diagnosis'),
    meta: {
      title: '质量诊断'
    }
  }]
}, {
  path: '/user/manage',
  redirect: '/user/manage/auth',
  component: LayoutManage,
  meta: {
    title: '用户管理',
    img: '4.png'
  },
  children: [{
    path: 'auth',
    component: () => import('@/views/manage/user/manage/auth'),
    meta: {
      title: '身份认证'
    }
  }, {
    path: 'authPersonal',
    hidden: true,
    component: () => import('@/views/manage/user/manage/authPersonal'),
    meta: {
      title: '个人认证',
      activeMenu: '/user/manage/auth'
    }
  }, {
    path: 'authFirm',
    hidden: true,
    component: () => import('@/views/manage/user/manage/authFirm'),
    meta: {
      title: '企业认证',
      activeMenu: '/user/manage/auth'
    }
  }, {
    path: 'authOther',
    hidden: true,
    component: () => import('@/views/manage/user/manage/authOther'),
    meta: {
      title: '其他机构组织认证',
      activeMenu: '/user/manage/auth'
    }
  }, {
    path: 'info',
    component: () => import('@/views/manage/user/manage/info'),
    meta: {
      title: '账户管理'
    }
  }, {
    path: 'editUpwd',
    component: () => import('@/views/manage/user/manage/editUpwd'),
    meta: {
      title: '修改密码'
    }
  }]
}]
export default routes
